const Url = {
  BASE: '/',
  AuthUser: '/clothingstoretemplate/auth/:psid',
  HOME: '/clothingstoretemplate',
  Auth: '/clothingstoretemplate/auth',
  Product: '/clothingstoretemplate/product:id',
  // Catalog: '/clothingstoretemplate/:id',
  CatalogueSlide: '/clothingstoretemplate/:id',
  Cart: '/clothingstoretemplate/cart',
  Checkout: '/clothingstoretemplate/checkout',
};

export default Url;
